module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-ex-white-on-red-dark-abebc01c11ac311b3bd6aff6d6fe24fb.svg";